/**
 * Magical timers that survive across page loads.
 * @constructor
 * @extends {Foundation.Timer}
 * @param {string} id Global timer identifier.
 * @param {number} milliseconds Timeout after this many milliseconds.
 */
Foundation.Timer.Persistent = function (id, milliseconds) {
    Foundation.Timer.call(this, milliseconds);
    
    /**
     * @protected
     * @type {string}
     */
    this.id = id;
        
    // Cancel timer that might already exist with this id.
    if (Foundation.Timer.Persistent.timers[this.id]) {
        Foundation.Timer.Persistent.timers[this.id].cancel();
    }
    
    // Keep this timer around.
    Foundation.Timer.Persistent.timers[this.id] = this;
    Foundation.Timer.Persistent.saveTimersToCookie();
    
    // Cleanups.
    this.always(this.destroy.bind(this));
};
Foundation.inherit(Foundation.Timer.Persistent, Foundation.Timer);

/**
 * Cookie that persistent timers will be stored in.
 * @type {Foundation.Cookie}
 * @private
 */
Foundation.Timer.Persistent.cookie = null;

/**
 * Mapping of ids to timers.
 * @private
 * @type {Object.<string,Foundation.Timer.Persistent>}
 */
Foundation.Timer.Persistent.timers = {};

/**
 * Flag to avoid saving the cookie. Lets the init function recreate timers
 * in a loop without a cookie being saved each time.
 * @private
 * @type {boolean}
 */
Foundation.Timer.Persistent.skipSave = false;

/**
 * Initialization of existing persistent timers. Called at the end of this file.
 * @private
 */
Foundation.Timer.Persistent.init = function () {
    Foundation.Timer.Persistent.cookie = new Foundation.Cookie("foundation-timers");
    Foundation.Timer.Persistent.cookie.ttl = 365 * 24 * 60 * 60;
    
    var data = Foundation.Timer.Persistent.cookie.getValue();
    if (data) {
        var now = (new Date()).getTime();

        var pairs = data.split(";");
    
        Foundation.Timer.Persistent.skipSave = true;
        for (var i = 0; i < pairs.length; i++) {
            var pair = pairs[i].split(":");
            var id = decodeURIComponent(pair[0]);
            
            var firesAt = parseInt(pair[1], 10);
            new Foundation.Timer.Persistent(id, firesAt - now);
        }
        Foundation.Timer.Persistent.skipSave = false;
        Foundation.Timer.Persistent.saveTimersToCookie();
    }
};

/**
 * Save the timers in a cookie.
 * @private
 */
Foundation.Timer.Persistent.saveTimersToCookie = function () {
    if (Foundation.Timer.Persistent.skipSave) return;
    
    var pairs = [];
    for (var id in Foundation.Timer.Persistent.timers) {
        var timer = Foundation.Timer.Persistent.timers[id];
        pairs.push(`${encodeURIComponent(id)}:${timer.firesAt}`);
    }
    
    if (pairs.length) {
        Foundation.Timer.Persistent.cookie.setValueAndSave(pairs.join(";"));
    }
    else {
        Foundation.Timer.Persistent.cookie.erase();
    }
};

/**
 * Get the already defined persistent timer for an id if it exists, otherwise null.
 * @return {Foundation.Timer.Persistent}
 */
Foundation.Timer.Persistent.timerForId = function (id) {
    if (Foundation.Timer.Persistent.timers[id]) {
        return Foundation.Timer.Persistent.timers[id];
    }
    else {
        return null;
    }
};

/**
 * Destructor.
 * @override
 */
Foundation.Timer.Persistent.prototype.destroy = function () {
    Foundation.Timer.prototype.destroy.call(this);
    
    delete Foundation.Timer.Persistent.timers[this.id];
    Foundation.Timer.Persistent.saveTimersToCookie();
};

// ---------------------------------------------------------------------

// Immediately initialize the persistent timers.
Foundation.Timer.Persistent.init();
